import { useEffect, useRef } from 'react';
import { useGlobalStore } from '@services/store/global-store';
import { useConfig } from '@components/ConfigProvider';

declare global {
  interface Window {
    digitalData?: any;
  }
}

import { UserDetails } from '@interfaces/user-details';
import { DtmDigitalData } from './digitalData';
import { IWindow } from 'src/models/iWindow';

const useDataAnalytics = (userData: UserDetails) => {
  let  _satellite: any;

  const getUserDataFromSession = (): UserDetails | null => {
    const userDataString = useGlobalStore.getState().userDetails;
    return userDataString;
  };
  const digitalData = new DtmDigitalData(userData, window as unknown as IWindow);
  const config = useConfig();

  useEffect(() => {
    digitalData.setSessionData(getUserDataFromSession(), config.VITE_ENV); 
    window.digitalData = digitalData.data;

   
  }, []);

  const pageChanged = (eventName?: string) => {
    digitalData.setSessionData(getUserDataFromSession(), config.VITE_ENV);

    digitalData.setPageData();
    window.digitalData = digitalData.data;
    console.log('window.digitalData page changed', window.digitalData);
    if (typeof _satellite !== 'undefined') {
        if (eventName) {
            _satellite.track(eventName);
        } else {
            _satellite.track('URLchanged');
        }
    }
  };

  return { pageChanged };
};

export default useDataAnalytics;